
/* CREDIT */
export const GET_CREDIT_LISTING = "GET_CREDIT_LISTING";
export const GET_CREDIT_LISTING_SUCCESS = "GET_CREDIT_LISTING_SUCCESS";
export const GET_CREDIT_LISTING_FAIL = "GET_CREDIT_LISTING_FAIL";

export const RESET_CREDIT_STATE = 'RESET_CREDIT_STATE';
export const RESET_CREDIT_ACTION_STATE = 'RESET_CREDIT_ACTION_STATE';